import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Smudgepainting extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 col-md-4 col-sm-6">
                      <img id="pain1" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img1_Jack.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-sm-0">
                      <img id="pain2" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img2_Emma.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-0">
                      <img id="pain3" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img3_sherlock.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-4">
                      <img id="pain4" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img4_Lenin.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4">
                      <img id="pain5" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img5_Rohith.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4">
                      <img id="pain6" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img6_Raja.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 pt-4">
                      <img id="pain7" width="100%" src={require('../../../Images/Daily_project/Smudge_painting/img8_3_Idiots.png')} alt="Case_studies_2" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Project</p>
                <p>
                  <AnchorLink href="#pain1" className="bullet">Jack sparrow</AnchorLink>
                  <br />
                  <AnchorLink href="#pain2" className="bullet">Emma watson</AnchorLink>
                  <br />
                  <AnchorLink href="#pain3" className="bullet">Iron man</AnchorLink>
                  <br />
                  <AnchorLink href="#pain4" className="bullet">Lenin</AnchorLink>
                  <br />
                  <AnchorLink href="#pain5" className="bullet">Rohith</AnchorLink>
                  <br />
                  <AnchorLink href="#pain6" className="bullet">Raja</AnchorLink>
                  <br />
                  <AnchorLink href="#pain7" className="bullet">3Idiots</AnchorLink>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ps.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}